import window from 'global';
import { stripTrailingSlash } from './utilities';

export default () => {
  const curPath = stripTrailingSlash(window.location.href);
  switch (true) {
  case curPath.includes('/dashboard'): {
    window.location = '/';
    break;
  }
  // eslint-disable-next-line no-empty
  default: {
    break;
  }
  }
};
